import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../libs/shared/helpers/src/internationalization/react';
import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {boxShadow} from '../../../../libs/shared/ui/src/theme/themeStyleHelpers';
import {StartGuideTaskTypesEnum} from '../../../models/api/preferencesModel';
import {SettingsHomeDestinationsEnum} from '../../../settings/home/settingsHomeTypes';
import {SettingsPanelId} from '../../../store/panels/panelStateBase';
import {OnboardingGuide} from '../onboardingGuide';
import {taskProgressComplete} from './adminOnboardingHelpers';
import {CreateInboxTask} from './tasks/createInboxTask';
import {ExploreRulesTask} from './tasks/exploreRulesTask';
import {InviteTeammatesTask} from './tasks/inviteTeammatesTask';

const StyledOnboardingGuide = styled(OnboardingGuide)`
  grid-column: 1 / span 6;
  grid-row: 1 / span 3;

  // Card styling
  border-radius: 16px;
  background: ${(p) => p.theme.foreground};
  ${(p) => boxShadow(p.theme, `0 1px 9px ${p.theme.alphas.black20}`)};
  border: 1px solid ${(p) => p.theme.alphas.black20};
  padding: 19px;
`;

/*
 * Props.
 */

interface AdminOnboardingGuideProps {
  settingsPanelId?: SettingsPanelId;
  onShortcutClick: HandlerOf<SettingsHomeDestinationsEnum>;
  shouldAddTeamInbox: boolean;
  shouldAddTeammate: boolean;
  shouldExploreRules: boolean;
  updateStartGuideTasks: (startGuideTask: StartGuideTaskTypesEnum) => void;
  progress: number;
}

export const AdminOnboardingGuide: FC<AdminOnboardingGuideProps> = ({
  onShortcutClick,
  shouldAddTeamInbox,
  shouldAddTeammate,
  shouldExploreRules,
  updateStartGuideTasks,
  progress,
}) => {
  if (progress === taskProgressComplete) {
    return null;
  }

  return (
    <StyledOnboardingGuide
      progress={progress}
      title={<Trans id="admin-onboarding-guide-title">Welcome to Front!</Trans>}
      description={
        <Trans id="admin-onboarding-guide-description">
          Follow our setup guide to get the most out of Front!
        </Trans>
      }
    >
      <CreateInboxTask
        isComplete={!shouldAddTeamInbox}
        onClick={() => onShortcutClick(SettingsHomeDestinationsEnum.ADD_TEAM_INBOX)}
      />
      <InviteTeammatesTask
        isComplete={!shouldAddTeammate}
        onClick={() => onShortcutClick(SettingsHomeDestinationsEnum.ADD_TEAMMATES)}
      />
      <ExploreRulesTask
        isComplete={!shouldExploreRules}
        onClick={() => {
          onShortcutClick(SettingsHomeDestinationsEnum.EXPLORE_RULES);
          updateStartGuideTasks(StartGuideTaskTypesEnum.ADD_TEAM_RULES);
        }}
      />
      {/* TODO-ONBOARD: The following tasks don't have existing shortcuts. */}
      {/* <ConnectChannelsTask isComplete={tasksCompleted[3]} /> */}
      {/* <CreateTeammateGroupsTask isComplete={tasksCompleted[4]} /> */}
    </StyledOnboardingGuide>
  );
};
